// extracted by mini-css-extract-plugin
export var item = "team-composition-item-module--item--AzCyh";
export var imageWrapper = "team-composition-item-module--image-wrapper--8FLTd";
export var image = "team-composition-item-module--image--bd0Yc";
export var title = "team-composition-item-module--title--8WSNY";
export var description = "team-composition-item-module--description--B8rDj";
export var surrounded = "team-composition-item-module--surrounded--gCceV";
export var supercoachImage = "team-composition-item-module--supercoach-image--3vwUt";
export var coachImage = "team-composition-item-module--coach-image--DWs4Z";
export var developerImage = "team-composition-item-module--developer-image--JWS9j";
export var designerImage = "team-composition-item-module--designer-image--hH3Op";
export var productOwnerImage = "team-composition-item-module--product-owner-image--wBUQT";
export var qaImage = "team-composition-item-module--qa-image--c3ME+";
export var surroundedImageWrapper = "team-composition-item-module--surrounded-image-wrapper--Lgpak";
export var designerImageWrapper = "team-composition-item-module--designer-image-wrapper--OUzGI";
export var productOwnerImageWrapper = "team-composition-item-module--product-owner-image-wrapper--QtqxK";
export var qaImageWrapper = "team-composition-item-module--qa-image-wrapper--Gjzlg";